import { FeatureFlagActionType } from '../../context/FeatureFlag/types';
import { FAL_PAPER_PLANE, FAL_SHIELD_CHECK } from '../../const/iconProps';
export var alertPreferencesUrl = 'alerts/preferences';
export var marketingPreferencesUrl = 'v1/marketing/preferences';
export var MarketingSettingsCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [marketingPreferencesUrl, { accountId: accountId, accountIdType: accountIdType }];
};
export var marketingPrivacySettingsCategories = {
    marketingSettings: {
        icon: FAL_PAPER_PLANE,
        preferenceType: ['EMAIL', 'MAIL'],
        flagName: FeatureFlagActionType.showMarketingSettings
    },
    privacySettings: {
        icon: FAL_SHIELD_CHECK,
        preferenceType: ['PRIVACY'],
        flagName: FeatureFlagActionType.showPrivacySettings
    }
};
export var PreferenceCategories;
(function (PreferenceCategories) {
    PreferenceCategories["MARKETING_SETTINGS"] = "marketingSettings";
    PreferenceCategories["PRIVACY_SETTINGS"] = "privacySettings";
})(PreferenceCategories || (PreferenceCategories = {}));
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["SUCCESS"] = "success";
    NotificationStatus["ERROR"] = "error";
})(NotificationStatus || (NotificationStatus = {}));
export var PRIVACY_TERMS_AND_CONDITIONS = {
    EN: 'https://www.synchrony.com/privacy-policy.html',
    ES: 'https://www.synchrony.com/privacy-policy-sp.html'
};
export var SETPAY_PAYLATER_PRODUCT_TYPE = [
    'INSTALLMENT_LOAN',
    'INSTALLMENT_LOAN_MONTHLY',
    'INSTALLMENT_LOAN_PAY_IN_FOUR'
];
